import { useState, useEffect, useRef, useCallback } from 'react';
export const useSwitcherPresenter = ({ value, onChange }) => {
  const [isChecked, setIsChecked] = useState(value);

  const checkBoxRef = useRef();

  const inputChangeHandler = useCallback((e) => {
    setIsChecked(e.target.checked);
    onChange(e);
  }, []);

  useEffect(() => {
    setIsChecked(value);
    checkBoxRef.current.checked = value;
  }, [value]);

  return { isChecked, checkBoxRef, inputChangeHandler };
};
